export const FETCH_MORE_DAMAGE_LIST = "FETCH_MORE_DAMAGE_LIST";
export const FETCH_DAMAGE_LIST = "FETCH_DAMAGE_LIST";
export const APPLY_DAMAGE_SORTING = "APPLY_DAMAGE_SORTING";
export const APPLY_DAMAGE_FILTER = "APPLY_DAMAGE_FILTER";
export const PUSH_DAMAGE_TO_LIST = "PUSH_DAMAGE_TO_LIST";
export const REMOVE_DAMAGE_FROM_LIST = "REMOVE_DAMAGE_FROM_LIST";
export const PATCH_DAMAGE_IN_LIST = "PATCH_DAMAGE_IN_LIST";
